import { Outlet, createFileRoute } from '@tanstack/react-router';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

function CrmSettingsLayout() {
	return <Outlet />;
}

export const Route = createFileRoute('/_authenticated/_app/crm/settings')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({
			context,
			anyOf: [
				'crmConfig.manageFields',
				'crmConfig.managePipelines',
				'crmConfig.manageLostReasons',
				'offers.manageSettings',
			],
			redirectTo: '/dashboard',
		}),
	component: CrmSettingsLayout,
});
